module.exports = __webpack_public_path__ + "static/media/p3-event.71068319.csv";